var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","duration":{ enter: 500, leave: 800 }}},[_c('div',{attrs:{"id":"toast-container"}},[_c('div',{staticClass:"toast message"},[_vm._v(" "+_vm._s(_vm.globalMessages)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }